import {
  glassGuideSearchResponse,
  glassGuideSimpleSearchResponse
} from './glass-guide.mock';

/**
 * Mock API Registry
 *
 * Each entry defines a mock route that the MockApiInterceptor will match against
 * outgoing HTTP requests. When a match is found, the interceptor returns the canned
 * response instead of hitting the network.
 *
 * Post-session, this file serves as a machine-readable API contract: backend developers
 * can read each entry to understand the URL pattern, HTTP method, and expected response
 * shape the UI requires. Remove entries as real endpoints are deployed.
 */

export interface MockRoute {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  urlPattern: string | RegExp;
  status: number;
  description: string;
  response: unknown | ((body: unknown) => unknown);
  delay?: number;
}

export const MOCK_ROUTES: MockRoute[] = [
  {
    method: 'POST',
    urlPattern: 'indexes/motglass-simplesearch-index/docs/search',
    status: 200,
    description:
      'Local Glass simple search (make/model/year) — Azure Search is not available locally',
    response: (body: unknown) => glassGuideSimpleSearchResponse(body)
  },
  {
    method: 'POST',
    urlPattern: 'indexes/motglass-search-index/docs/search',
    status: 200,
    description:
      'Local Glass vehicle search (NVIC + ABOVE_AVERAGE_PR) — Azure Search is not available locally',
    response: (body: unknown) => glassGuideSearchResponse(body)
  }
];
